module.exports = __webpack_public_path__ + "assets/img/bj.209f4841.png";